/**
 * Ticker Fundamentals
 *
 * @module
 */

import { $$ } from '../../../utilities/QuerySelectors.js';
import { chunk } from 'lodash-es';

class ExtraInfoToChartInfo {
    /**
     * @param {Element} chartInfo
     * @param {Element} extraInfo
     */
    constructor(chartInfo, extraInfo) {
        this.chartInfo = chartInfo;
        this.extraInfo = extraInfo;
    }

    /**
     * Copy the figure from above the chart into the area below the chart.
     *
     * @private
     * @param {Element} sourceItem Core figure container.
     * @return {HTMLDivElement}
     */
    cloneItem(sourceItem) {
        const title = sourceItem.querySelector('.core-figure-name').textContent;
        const value = sourceItem.querySelector('.core-figure-value').textContent;
        const chartItem = document.createElement('div');

        chartItem.className = 'financial-info-item';
        chartItem.innerHTML = `<h5>${title}</h5><p>${value}</p>`;
        return chartItem;
    }

    /**
     * Clone the core figures from a vertical set of three into horizontal sets.
     *
     * @return {void}
     */
    cloneInto() {
        const items = $$('.inner-container > div', this.extraInfo).slice(3).map(this.cloneItem.bind(this));

        chunk(items, 2)
            .map((sectionItems) => {
                const section = document.createElement('div');
                section.className = 'financial-info-section fundamentals-section';
                sectionItems.forEach((item) => section.appendChild(item));
                return section;
            })
            .forEach((section) => this.chartInfo.insertAdjacentElement('afterbegin', section));

        this.chartInfo.classList.add('fouc-ready');
    }
}

class FoolStockTableToChartInfo {
    /**
     * @param {Element} chartInfo
     * @param {Element} foolStockTable
     */
    constructor(chartInfo, foolStockTable) {
        this.chartInfo = chartInfo;
        this.foolStockTable = foolStockTable;
    }

    /**
     * Copy the figure from above the chart into the area below the chart.
     *
     * @private
     * @param {Element} sourceItem Core figure container.
     * @return {HTMLDivElement}
     */
    cloneItem(sourceItem) {
        const title = sourceItem.querySelector('strong').textContent;
        const value = sourceItem.querySelector('span').textContent;
        const chartItem = document.createElement('div');

        chartItem.className = 'financial-info-item';
        chartItem.innerHTML = `<h5>${title}</h5><p>${value}</p>`;
        return chartItem;
    }

    /**
     * Clone the core figures from a vertical set of three into horizontal sets.
     *
     * @return {void}
     */
    cloneInto() {
        const items = Array.from(this.foolStockTable.children).map(this.cloneItem.bind(this));

        chunk(items, 4)
            .map((sectionItems) => {
                const section = document.createElement('div');
                section.className = 'financial-info-section';
                sectionItems.forEach((item) => section.appendChild(item));
                return section;
            })
            .forEach((section) => this.chartInfo.insertAdjacentElement('afterbegin', section));

        this.chartInfo.classList.add('fouc-ready');
    }
}

/**
 * Clone the financial fundamental info so it can be displayed in various areas of the theme
 * for different screen sizes.
 */
export function init() {
    const chartInfo = document.querySelector('.chart-financial-info');
    const extraInfo = document.querySelector('.ticker-extra-info');
    const foolStockTable = document.querySelector('.company-data-table');

    if (extraInfo && chartInfo) {
        new ExtraInfoToChartInfo(chartInfo, extraInfo).cloneInto();
    }

    if (chartInfo && foolStockTable) {
        new FoolStockTableToChartInfo(chartInfo, foolStockTable).cloneInto();
    }
}
